import React, { Fragment, useEffect, useState } from 'react'
import FsLightbox from 'fslightbox-react';

import { Row, Col, Image, Form, Nav, Dropdown, Tab, OverlayTrigger, Popover, Badge, Tooltip } from 'react-bootstrap'
import Card from '../../../components/Card'

import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
// img

import avatars11 from '../../../assets/images/avatars/01.png'
import avatars22 from '../../../assets/images/avatars/avtar_1.png'
import avatars33 from '../../../assets/images/avatars/avtar_2.png'
import avatars44 from '../../../assets/images/avatars/avtar_3.png'
import avatars55 from '../../../assets/images/avatars/avtar_4.png'
import avatars66 from '../../../assets/images/avatars/avtar_5.png'
import avatars2 from '../../../assets/images/avatars/02.png'
import avatars3 from '../../../assets/images/avatars/03.png'
import avatars4 from '../../../assets/images/avatars/04.png'
import avatars5 from '../../../assets/images/avatars/05.png'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import avatar1 from "../../../assets/images/avatars/01.png"

import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import pages2 from '../../../assets/images/pages/02-page.png'

import ShareOffcanvas from '../../../components/partials/components/shareoffcanvas'
import { userSignal } from '../../../signal/userSignal';
import * as moment from 'moment';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { DEV_SERVER } from '../../../constants/urls';
import axios from 'axios';
import TripListOfUser from '../trips/TripListOfUser';
import PerformanceChart from '../trips/performance-chart';
import Attendence from '../attendence/Attendence';
import ExpenseListOfUser from '../expenses/ExpenseListOfUser';
import LeavesListOfUser from '../leaves/LeaveListOfUser';
import Circularprogressbar from '../../../components/circularprogressbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from "swiper";
import { userExcelGenerator } from '../../../utilities/excelGenerator';
import ExcelExport from "../../../assets/images/icons/excel-export.svg"
import { organisationSignal } from '../../../signal/organisationSignal';
import OrderListOfUser from '../order/OrderListOfUser';
import Avatar from 'react-avatar';
import CountUp from 'react-countup';
import DataTable from 'react-data-table-component';
import { allUsersSignal } from '../../../signal/allUsersSignal';
import AccStatement from './AccStatement';

// install Swiper modules
SwiperCore.use([Navigation]);

const DealerProfile = (props) => {

    let today = new Date()
    today = new Date(today).getTime();
    // get date start Time of month's first day
    let monthStartDay = new Date(new Date(today).getFullYear(), new Date(today).getMonth(), 1).getTime();
    const [searchParams, setSearchParams] = useSearchParams();
    const [toggler, setToggler] = useState();
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(monthStartDay).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [orders, setOrders] = useState([]);
    const [payments, setPayments] = useState([]);
    const [visits, setVisits] = useState([]);
    const [dealer, setDealer] = useState({});
    const [visitPage, setVisitPage] = useState(1);
    const [visitPerPage, setVisitPerPage] = useState(35);
    const [orderSummary, setOrderSummary] = useState({
        totalOrders: 0,
        totalOrderValue: 0,
    });
    const [paymentSummary, setPaymentSummary] = useState({
        totalPayments: 0,
        totalPaymentValue: 0,
    });
    const [visitSummary, setVisitSummary] = useState(0)

    const url = useLocation();
    const navigate = useNavigate();
    const id = url.pathname.split("/")[3];

    const getVariableColor = () => {
        let prefix =
            getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
        if (prefix) {
            prefix = prefix.trim();
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary`
        );
        const color2 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}info`
        );
        const color3 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary-tint-20`
        );
        const color4 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}warning`
        );
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    };
    const variableColors = getVariableColor();

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
        return () => colors;
    });

    const dealerDetails = useQuery("dealerDetails", async () => {
        let resp = await axios.get(`${DEV_SERVER}/dealer/v2/${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setDealer(data.data);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            console.log(error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");

            }
            navigate("/dashboard/dealers");
        }
    })

    const ordersQuery = useQuery("ordersQuery", async () => {
        let resp = await axios.get(`${DEV_SERVER}/order/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 59)}&dealerId=${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setOrders(data?.data);

                let _totalOrders = 0
                let _totalOrderValue = 0

                for (let i = 0; i < data?.data?.length; i++) {
                    _totalOrders += 1
                    _totalOrderValue += data.data[i].totalAmount
                }

                setOrderSummary({
                    totalOrders: _totalOrders,
                    totalOrderValue: _totalOrderValue
                })

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const paymentsQuery = useQuery("paymentsQuery", async () => {
        let resp = await axios.get(`${DEV_SERVER}/payment/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 59)}&dealerId=${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            console.log("Payments api response Data", data);
            if (data.status) {
                setPayments(data?.data);

                let _totalPayments = 0
                let _totalPaymentValue = 0

                for (let i = 0; i < data?.data?.length; i++) {
                    _totalPayments += 1
                    _totalPaymentValue += data.data[i].amount
                }

                setPaymentSummary({
                    totalPayments: _totalPayments,
                    totalPaymentValue: _totalPaymentValue
                })
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const getVisits = useQuery("dealerVisits", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/trip/v2/task/getDealerVisits?page=${visitPage}&perPage=${visitPerPage}&startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 59)}&dealerId=${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setVisits(data.data?.data || []);
                setVisitPage(data.data?.page || 1);
                setVisitPerPage(data.data?.perPage || 35);
                setVisitSummary(data.data?.totalItems || 0);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const orderRefetch = () => {
        ordersQuery.refetch({ cancelRefetch: true });
    }

    const paymentRefetch = () => {
        paymentsQuery.refetch({ cancelRefetch: true });
    }

    const visitRefetch = () => {
        getVisits.refetch({ cancelRefetch: true });
    }

    useEffect(() => {
        dealerDetails.refetch({ cancelRefetch: true });
        ordersQuery.refetch({ cancelRefetch: true });
        paymentsQuery.refetch({ cancelRefetch: true });
        getVisits.refetch({ cancelRefetch: true });
    }, [])


    const handleDateChange = (e) => {

        let tempSearch = new URLSearchParams({
            fromDate: fromDate,
            toDate: toDate
        })

        setSearchParams(tempSearch);

        ordersQuery.refetch({ cancelRefetch: true });
        paymentsQuery.refetch({ cancelRefetch: true });
        getVisits.refetch({ cancelRefetch: true });
    }

    const paymentColumns = [
        {
            name: "Remark",
            color: true,
            center: true,
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.remark}</Tooltip>}><span>{row?.remark}</span></OverlayTrigger>

            },
        },
        {
            name: "Amount",
            color: true,
            center: true,
            selector: "amount",
            cell: (row) => `₹ ${parseFloat(row?.amount).toFixed(2)}`,
            sortable: true,
        },
        {
            name: "Payment Type",
            color: true,
            center: true,
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.paymentType}</Tooltip>}>
                    <span>{row?.paymentType}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Date",
            color: true,
            center: true,
            selector: "createdAt",
            cell: (row) => moment(row?.createdAt).format("DD/MM/YY hh:mm A"),
            sortable: true,
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.media?.length > 0 && row?.media?.map((m) =>
                    <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>

                )}
            </div>
        },
        {
            name: "User",
            color: true,
            center: true,
            selector: (row) => {
                if (row?.userId?.length > 0) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.userId[0]?.name}</Tooltip>}>
                        <span style={{ display: "flex", columnGap: "0.5rem", alignItems: "center" }}>
                            <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={row?.userId[0].profileURL !== "" ? row?.userId[0].profileURL : avatar1} />
                            {row?.userId[0].name}
                        </span>
                    </OverlayTrigger>
                } else {
                    return "NA"
                }
            }
        },
        {
            name: "Status",
            color: true,
            center: true,
            selector: (row) => <span style={{ color: row?.status === "pending" ? "orange" : (row?.status === "cleared" ? "green" : "red") }}>{row?.status}</span>
        },

        {
            name: "Reason",
            color: true,
            center: true,
            selector: (row) => {
                return row?.reason === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reason}</Tooltip>}><span>{row?.reason}</span></OverlayTrigger>
            }
        },
    ]

    const visitsColumns = [
        {
            name: "Title",
            selector: "tasks.title",
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.tasks?.title}</Tooltip>}>
                    <span>{row?.tasks?.title}</span>
                </OverlayTrigger>
            },
            center: true,
        },
        {
            name: "Description",
            selector: "tasks.description",
            center: true,
            cell: (row) => {
                return row?.tasks?.description === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.tasks?.description}</Tooltip>}>
                    <span>{row?.tasks?.description}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Status",
            selector: (row) => {
                return row?.tasks?.status === "pending" ? <Badge bg="warning">{row?.tasks?.status}</Badge> : <Badge bg="success">{row?.tasks?.status}</Badge>
            },
            center: true,
            width: "100px"
        },
        {
            name: "Remarks",
            selector: "tasks.remarks",
            center: true,
            cell: (row) => {
                return row?.tasks?.remarks === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.tasks?.remarks}</Tooltip>}>
                    <span>{row?.tasks?.remarks}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Remark image",
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.tasks?.media?.length > 0 && row?.tasks?.media.map((url, index) =>
                    <Zoom key={index}><img src={url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>
                )}
            </div>
        },
        {
            name: "Address",
            selector: (row) => {
                // Build address parts array, filtering out empty/undefined values
                const addressParts = [
                    row?.tasks?.destinationArea,
                    row?.tasks?.destinationCity,
                    row?.tasks?.destinationState
                ].filter(part => part && part !== "");

                // Join valid parts with comma separator
                const address = addressParts.join(", ");

                return <OverlayTrigger placement="top" overlay={
                    <Tooltip style={{ position: "fixed" }}>
                        {address || "No address available"}
                    </Tooltip>
                }>
                    <span>{address || "No address available"}</span>
                </OverlayTrigger>
            },
            width: "300px",
            center: true,
        },
        {
            name: "User",
            selector: (row) => {
                if (row?.user?._id) {
                    return (
                        <div style={{ columnGap: "0.4rem" }}>
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {row?.user?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{row?.user?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            },
            center: true,
            width: "150px"
        },
        {
            name: "Completed Location",
            width: "100px",
            selector: (row) => {
                return <span className="d-flex justify-content-between align-items-start" style={{ columnGap: "0.5rem" }}>
                    {(row?.tasks?.completedAt === "" || row?.tasks?.completedAt === null || row?.tasks?.completedAt === undefined || row?.tasks?.completedAt === 0) ? "-" :
                        <span className="d-flex flex-column">
                            <p className="mb-1">{moment(row?.tasks?.completedAt).format("DD/MM/YY")}</p>
                            <p className="mb-0" style={{ color: "rgba(0, 0, 0, 0.625)", fontSize: "10px" }}>{moment(row?.tasks?.completedAt).format("hh:mm A")}</p>
                        </span>
                    }

                    {row?.tasks?.completedAtLocation?.length > 0 && <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.tasks?.completedAtLocation[0]},${row?.tasks?.completedAtLocation[1]}`} target="_blank" ><i className="fas fa-map-marker-alt"></i></a></OverlayTrigger>}

                </span>
            },
            center: true,
        }
    ]

    const calculateOutStandings = () => {
        try {
            let tallyDetails = dealer?.tallyDetails
            let totalOutstanding = 0

            if (tallyDetails) {
                for (let i = 0; i < tallyDetails.length; i++) {
                    totalOutstanding += tallyDetails[i].outstanding
                }
                return totalOutstanding
            } else {
                return dealer?.outStanding || 0
            }

        } catch (err) {
            return dealer?.outStanding || 0
        }
    }

    const getOutStandings = () => {
        let resp = calculateOutStandings()

        return {
            totalOutstanding: resp,
            formatedOutstanding: `₹ ${resp < 0 ? '-' : ''}${Math.abs(resp) > 1000 ? parseFloat(Math.abs(resp) / 1000).toFixed(2) + "K" : parseFloat(Math.abs(resp)).toFixed(2)}`
        }

    }

    return (
        <Fragment>
            <FsLightbox
                toggler={toggler}
                sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
            />
            {(dealerDetails.isLoading) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-primary m-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div> :
                <Tab.Container defaultActiveKey="first">
                    <Row>
                        <Col lg="12" style={{ marginTop: "3rem" }}>
                            <Card>
                                <Card.Body>
                                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                                        <div className="d-flex flex-wrap align-items-center">
                                            <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                                                {(dealer?.visitingCard?.length && dealer?.visitingCard?.length !== 0) ? <Image className="rounded-circle img-fluid avatar-100" src={dealer?.visitingCard[0]?.url} alt="profile-img" /> : <>
                                                    <Avatar name={dealer?.name} round style={{ borderRadius: "50% !important", margin: "0px auto", position: "relative", width: "200px !important", height: "200px !important" }} />
                                                </>}
                                            </div>
                                            <div className='d-flex flex-column'>
                                                <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                                                    <h4 className="me-2 h4">{dealer?.name}</h4>
                                                </div>
                                                <div className="d-flex flex-wrap align-items-center">
                                                    {dealer?.phoneNumber}
                                                </div>
                                            </div>

                                        </div>
                                        <div className='d-flex flex-column justify-self-right'>
                                            <h2 className={`counter text-${getOutStandings()?.totalOutstanding < 0 ? "danger" : "success"}`} >{getOutStandings()?.formatedOutstanding}</h2>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg="12">
                            <Card>
                                <Card.Body>
                                    <Row className="row-cols-1">
                                        <div className="d-slider1 ">
                                            <Swiper
                                                className="p-0 m-0 mb-2 list-inline "
                                                slidesPerView={5}
                                                spaceBetween={32}
                                                navigation={{
                                                    nextEl: ".swiper-button-next",
                                                    prevEl: ".swiper-button-prev",
                                                }}
                                                breakpoints={{
                                                    320: { slidesPerView: 1 },
                                                    550: { slidesPerView: 2 },
                                                    991: { slidesPerView: 3 },
                                                    1400: { slidesPerView: 3 },
                                                    1500: { slidesPerView: 4 },
                                                    1920: { slidesPerView: 4 },
                                                    2040: { slidesPerView: 7 },
                                                    2440: { slidesPerView: 8 }
                                                }}

                                            >
                                                <SwiperSlide className="card card-slide" >
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.primary}
                                                                width="60px"
                                                                height="60px"
                                                                Linecap="rounded"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                style={{ width: 60, height: 60 }}
                                                                value={90}
                                                                id="circle-progress-01"
                                                            >
                                                                {orderSummary?.totalOrders === 0 ?
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                        />
                                                                    </svg> :
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24px"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                        />
                                                                    </svg>}
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Orders</p>
                                                                <h4 className="counter">
                                                                    {orderSummary?.totalOrders}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide className=" card card-slide">
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.info}
                                                                width="60px"
                                                                height="60px"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                Linecap="rounded"
                                                                style={{ width: 60, height: 60 }}
                                                                value={60}
                                                                id="circle-progress-02"
                                                            >
                                                                {orderSummary?.totalOrderValue === 0 ?
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                        />
                                                                    </svg> :
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24px"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                        />
                                                                    </svg>}
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Order Value</p>
                                                                <h4 className="counter">
                                                                    ₹ {orderSummary?.totalOrderValue > 1000 ? (orderSummary?.totalOrderValue / 1000).toFixed(2) + "K" : parseFloat(orderSummary?.totalOrderValue).toFixed(2)}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide className=" card card-slide">
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.primary}
                                                                width="60px"
                                                                height="60px"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                Linecap="rounded"
                                                                style={{ width: 60, height: 60 }}
                                                                value={70}
                                                                id="circle-progress-03"
                                                            >
                                                                <svg className="" width="24" viewBox="0 0 24 24">
                                                                    <path
                                                                        fill="currentColor"
                                                                        d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                    />
                                                                </svg>
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Payments</p>
                                                                <h4 className="counter">
                                                                    ₹ {(parseFloat(paymentSummary?.totalPaymentValue) > 1000 ? parseFloat(parseFloat(paymentSummary?.totalPaymentValue) / 1000).toFixed(2) + "K" : parseFloat(parseFloat(paymentSummary?.totalPaymentValue)).toFixed(2))}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide className=" card card-slide">
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.info}
                                                                width="60px"
                                                                height="60px"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                Linecap="rounded"
                                                                style={{ width: 60, height: 60 }}
                                                                value={60}
                                                                id="circle-progress-04"
                                                            >
                                                                {visitSummary === 0 ?
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                        />
                                                                    </svg> :
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24px"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                        />
                                                                    </svg>}
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Visits</p>
                                                                <h4 className="counter">
                                                                    {visitSummary}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>

                                                <div className="swiper-button swiper-button-next"></div>
                                                <div className="swiper-button swiper-button-prev"></div>
                                            </Swiper>
                                        </div>
                                    </Row>
                                    <div style={{ display: "flex", alignItems: "start", columnGap: "1rem", marginBottom: "1rem" }}>
                                        <div style={{ display: "flex", alignItems: "start", columnGap: "1rem", marginBottom: "1rem" }}>
                                            <div>
                                                <label htmlFor="fromDate">From Date</label>
                                                <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                            </div>
                                            <div>
                                                <label htmlFor="toDate">To Date</label>
                                                <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                            </div>
                                            <button className='btn btn-primary align-self-end' onClick={handleDateChange}>Submit</button>
                                        </div>
                                        <div style={{ alignSelf: "flex-start", flexGrow: 1 }} className="d-flex align-items-start justify-content-end">
                                            <OverlayTrigger trigger="click" placement="left" overlay={
                                                <Popover
                                                    id="popover-basic"
                                                    placement="left"
                                                    title=""
                                                >
                                                    <Card className="mb-0">
                                                        <Card.Header>
                                                            <div className="header-title">
                                                                <h4 className="card-title">About</h4>
                                                            </div>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <p>{`${dealer.address !== "" ? dealer.address + ", " : ""} ${dealer.city !== "" ? dealer.city + ", " : ""} ${dealer.state !== "" ? dealer.state + ", " : ""} ${dealer.pincode !== "" && dealer.pincode !== 0 ? dealer.pincode : ""}`}</p>
                                                            <div className="mb-1">Email: <Link to={`mailto:${dealer?.email}`} className="ms-3">{dealer?.email}</Link></div>
                                                            <div className="mb-1">Website: <Link to={dealer?.website} className="ms-3">{dealer?.website}</Link></div>
                                                            <div>Group: <span className="ms-3">{dealer?.group}</span></div>
                                                            <div>GST No: <span className="ms-3">{dealer?.gstin}</span></div>
                                                            <div>About Party: <span className="ms-3">{dealer?.aboutParty}</span></div>
                                                        </Card.Body>
                                                    </Card>
                                                </Popover>
                                            }>
                                                <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.334 2.75H7.665C4.644 2.75 2.75 4.889 2.75 7.916V16.084C2.75 19.111 4.635 21.25 7.665 21.25H16.333C19.364 21.25 21.25 19.111 21.25 16.084V7.916C21.25 4.889 19.364 2.75 16.334 2.75Z" stroke="#096DD9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M11.9946 16V12" stroke="#096DD9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    <path d="M11.9896 8.2041H11.9996" stroke="#096DD9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <Nav as="ul" className="d-flex nav-pills mb-0 text-center profile-tab" data-toggle="slider-tab" id="profile-pills-tab" role="tablist">
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="first">Orders</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="second">Payments</Nav.Link>
                                            </Nav.Item>
                                            {(organisationSignal?.value?.isTallyIntegrationActivated && dealer?.isTallyDealer === true) && <Nav.Item as="li">
                                                <Nav.Link eventKey="third">Acc Statement</Nav.Link>
                                            </Nav.Item>}
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="fourth">Visits</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item as="li">
                                            <Nav.Link eventKey="fourth">Profile</Nav.Link>
                                        </Nav.Item> */}
                                        </Nav>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Tab.Content className="profile-content">
                                {<Tab.Pane eventKey="first" id="profile-activity">
                                    {(ordersQuery?.isLoading || ordersQuery?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> : <OrderListOfUser orders={orders} />}
                                </Tab.Pane >}
                                {<Tab.Pane eventKey="second" id="profile-activity">
                                    {(paymentsQuery?.isLoading || paymentsQuery?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> :
                                        <div>
                                            <Row>
                                                <Col sm="12">
                                                    <Card>
                                                        <Card.Header className="d-flex justify-content-between">
                                                            <div className="header-title">
                                                                <h4 className="card-title">Payment List</h4>
                                                            </div>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <DataTable
                                                                columns={paymentColumns}
                                                                data={payments}
                                                                pagination
                                                                paginationPerPage={35}
                                                                paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}

                                                            />
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>

                                    }
                                </Tab.Pane >}
                                {(organisationSignal?.value?.isTallyIntegrationActivated && dealer?.isTallyDealer === true) && <Tab.Pane eventKey={"third"} id="profile-accStatement">
                                    <AccStatement dealerId={dealer?.id} dealerName={dealer?.name} />
                                </Tab.Pane>}
                                {<Tab.Pane eventKey="fourth" id="profile-activity">
                                    {(getVisits?.isLoading || getVisits?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> :
                                        <div>
                                            <Row>
                                                <Col sm="12">
                                                    <Card>
                                                        <Card.Header className="d-flex justify-content-between">
                                                            <div className="header-title">
                                                                <h4 className="card-title">Visits</h4>
                                                            </div>
                                                        </Card.Header>
                                                        <Card.Body>
                                                            <DataTable
                                                                customStyles={{ cells: "center" }} columns={visitsColumns} data={visits} pagination={true}
                                                                paginationServer={true} paginationTotalRows={visitSummary} paginationPerPage={visitPerPage} paginationRowsPerPageOptions={[10, 20, 30, 35, 40, 50]}
                                                                paginationDefaultPage={visitPage}
                                                                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                                                    setVisitPerPage(currentRowsPerPage);
                                                                }
                                                                } onChangePage={(currentPage) => {
                                                                    setVisitPage(currentPage);
                                                                }}
                                                            />
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </div>
                                    }
                                </Tab.Pane >}
                                {/* <Tab.Pane eventKey="fourth" id="profile-activity">
                                    {(expensesMutation?.isLoading || expensesMutation?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> : <ExpenseListOfUser expenses={expenses} expenseRefetch={expenseRefetch} />}
                                </Tab.Pane >
                                <Tab.Pane eventKey="fifth" id="profile-activity">
                                    {(expensesMutation?.isLoading || expensesMutation?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> : <LeavesListOfUser leaves={leaves} leaveRefetch={leaveRefetch} />}
                                </Tab.Pane >
                                <Tab.Pane eventKey="sixth" id="profile-friends">
                                    {(employeeAttendence.isLoading || employeeAttendence?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden tets2">Loading...</span>
                                        </div>
                                    </div> : <Attendence attendences={attendences} fromDate={fromDate} toDate={toDate} />}
                                </Tab.Pane > */}
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            }
        </Fragment>
    )

}

export default DealerProfile;